var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSoldOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 28,
    viewBox: "0 0 40 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 26C40 24.9 39.1 24 38 24H2C0.9 24 0 24.9 0 26C0 27.1 0.9 28 2 28H38C39.1 28 40 27.1 40 26ZM24 4C24 4.56 23.88 5.1 23.68 5.58C31.5 7.2 37.46 13.86 38 22H2C2.54 13.86 8.5 7.2 16.32 5.58C16.12 5.1 16 4.56 16 4C16 1.8 17.8 0 20 0C22.2 0 24 1.8 24 4ZM15.4691 8.4C15.1856 8.4 14.9136 8.51262 14.7131 8.7131C14.5126 8.91363 14.4 9.18558 14.4 9.46914C14.4 9.75269 14.5126 10.0246 14.7131 10.2252L18.4944 14.0065L14.7131 17.7877C14.5183 17.9894 14.4105 18.2595 14.413 18.5399C14.4154 18.8203 14.5279 19.0885 14.7261 19.2868C14.9244 19.4851 15.1926 19.5975 15.473 19.6C15.7534 19.6024 16.0235 19.4946 16.2252 19.2998L20.0065 15.5185L23.7877 19.2998C23.9894 19.4946 24.2595 19.6024 24.5399 19.6C24.8203 19.5975 25.0885 19.4851 25.2868 19.2868C25.4851 19.0885 25.5975 18.8203 25.6 18.5399C25.6024 18.2595 25.4946 17.9894 25.2998 17.7877L21.5185 14.0065L25.2998 10.2252C25.4946 10.0235 25.6024 9.75337 25.6 9.47299C25.5975 9.1926 25.4851 8.92439 25.2868 8.72612C25.0885 8.52785 24.8203 8.41539 24.5399 8.41295C24.2595 8.41052 23.9894 8.5183 23.7877 8.7131L20.0065 12.4944L16.2252 8.7131C16.0246 8.51262 15.7527 8.4 15.4691 8.4Z",
    fill: "url(#paint0_linear_186_1168)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_186_1168",
    x1: 20,
    y1: 0,
    x2: 20,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDC33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9B227"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoldOut);
export default __webpack_public_path__ + "static/media/sold-out.80597713.svg";
export { ForwardRef as ReactComponent };